import {Component, Input} from '@angular/core';
import {ITableColumn} from 'app/main/shared/shared/table/table-column';
import {uniqueArray} from '../../../../../../global/unique-array';
import {ITableCellItem} from '../../../../../shared/shared/table/table-cell';
import {IDocumentDto, IRecipient_rolesDto} from '../../../dto/document-listing.dto';
import {setOrgnizationData} from 'app/global/get-recipient-data';
import {Organization} from 'app/main/pages/edit-template/edit-template.dto';
import { OrganizationView } from 'app/main/shared/shared/table/models/organization-view.model';

@Component({
    selector: 'app-organiztaion-column',
    templateUrl: './organiztaion-column.component.html',
    styleUrl: './organiztaion-column.component.scss'
})
export class OrganizationColumnComponent implements ITableCellItem {
    organizations: OrganizationView[] = [];

    @Input() set dataItem(dataItem: IDocumentDto) {
        if (dataItem && dataItem['recipient_roles']) {
            this.organizations = uniqueArray<IRecipient_rolesDto>(dataItem['recipient_roles'] || [], 'id')
                .filter(x => x.organization != null)
                .map(x => {
                    if (!x.orgfields) {
                        return null;
                    }

                    const organization:Organization = setOrgnizationData(x.orgfields);
                    return {
                        name: organization?.name || '',
                        id: x?.organization?.id
                    }
                })
                .filter(item => item !== null)
                .map(this.toOrganizationView);
        }
    }


    @Input() columnOptions: ITableColumn;

    private toOrganizationView(item: { name: string }): OrganizationView | null {
        return {
            name: item.name ? item.name : '',
            isDeleted: false
        };
    }
}
